/**
 * Entwicklerschulung Prompts
 *
 * Prompt-Templates für praktische Übungen und Aufgaben
 * This is a stub for the prompts used in entwicklerschulung-tag1 presentation
 */

export const entwicklerschulungPrompts = {
  categorization: {
    title: '📝 KI-Systeme kategorisieren',
    description: 'Systematische Kategorisierung verschiedener KI-Systeme',
    prompt: 'Prompts content would go here...',
    tags: ['Übung', 'KI-Grundlagen', '10 Min']
  },
  llmCodeTasks: {
    title: '✏️ LLM für Code-Aufgaben nutzen',
    description: 'Praktische Coding-Challenges mit verschiedenen Schwierigkeitsgraden',
    prompt: 'Prompts content would go here...',
    tags: ['Coding', 'LLM', '15 Min']
  },
  promptImprovement: {
    title: '💭 Prompt Verbesserung',
    description: 'Schlechte Prompts in professionelle umwandeln',
    prompt: 'Prompts content would go here...',
    tags: ['Prompt Engineering', 'Interaktiv', '15 Min']
  },
  toolSetup: {
    title: '🛠️ AI-Tool Installation',
    description: 'Schritt-für-Schritt Setup Ihres bevorzugten AI-Coding-Tools',
    prompt: 'Prompts content would go here...',
    tags: ['Setup', 'Tools', '15 Min']
  },
  ecommerceApi: {
    title: '🛠️ E-Commerce Product API',
    description: 'Vollständige API mit Node.js, Express und TypeScript',
    prompt: 'Prompts content would go here...',
    tags: ['Workshop', 'API', '40 Min']
  },
  legacyModernization: {
    title: '🛠️ Legacy Code Modernisierung',
    description: 'Callback Hell → Async/Await & ES6+ Features',
    prompt: 'Prompts content would go here...',
    tags: ['Refactoring', 'ES6+', '30 Min']
  },
  testCoverage: {
    title: '🛠️ Test Coverage erhöhen',
    description: 'Automatische Test-Generierung mit Copilot',
    prompt: 'Prompts content would go here...',
    tags: ['Testing', 'Jest', '20 Min']
  },
  contextEngineering: {
    title: '🎯 Context Engineering Grundlagen',
    description: 'Systematische KI-Entwicklung für bessere Ergebnisse',
    prompt: 'Prompts content would go here...',
    tags: ['Context Engineering', 'Best Practices', '15 Min']
  }
} as const

export default entwicklerschulungPrompts
